export const pic02 = new URL('./pic02.jpg', import.meta.url) + '';
export const pic07 = new URL('./pic07.jpg', import.meta.url) + '';
export const pic15 = new URL('./pic15.jpg', import.meta.url) + '';
export const pic16 = new URL('./pic16.jpg', import.meta.url) + '';
export const pic17 = new URL('./pic17.jpg', import.meta.url) + '';
export const pic18 = new URL('./pic18.jpg', import.meta.url) + '';
export const pic19 = new URL('./pic19.jpg', import.meta.url) + '';
export const pic20 = new URL('./pic20.jpg', import.meta.url) + '';
